/* eslint-env browser */
import cookies from 'js-cookie';

import PasswordChecker from './classes/PasswordChecker';
import PasswordTakeover from './classes/PasswordTakeover';

import './styles/_styles.scss';

const showPasswordDialog = () => {
  const {
    hashedPassword = '',
    salt = '',
    title = '',
    prompt = '',
    error = '',
  } = window.bgmpPasswordData;

  const passwordChecker = new PasswordChecker({ hashedPassword, salt });

  const cookieName = `bgmp-password-${salt}`;

  if (hashedPassword) {
    const passwordTakeover = new PasswordTakeover({
      title,
      prompt,
      error,
      passwordChecker,
      cookieName,
    });

    // Check to see if the password cookie has already been set.
    const storedPassword = cookies.get(cookieName);
    if (storedPassword && passwordChecker.checkPassword(storedPassword)) {
      passwordTakeover.hide();
    }
  }
};

document.addEventListener('DOMContentLoaded', showPasswordDialog);
